import { type Venue, type Product, Menu, MenuVariant } from 'generated/graphql';
import { NestedCategory, formattedCategory } from 'types';
import { CATEGORY_ITEM_IDENTIFIER } from './index';

export const getAllMenuItems = (venue: Venue | undefined | null): Product[] => {
  const allMenuItems: Product[] = [];

  venue?.menus?.forEach((menu) => {
    if (menu.neverPublished) return;
    menu?.products?.forEach((product) => {
      const productWithMmIdExists = allMenuItems.find((item) => item?.mmId === product?.mmId);
      if (!productWithMmIdExists) {
        allMenuItems.push(product);
      }
    });
  });

  return allMenuItems;
};

export const getAllMenuVariants = (venue: Venue | undefined | null): MenuVariant[] => {
  const allMenuVariants: MenuVariant[] = [];

  venue?.menus?.forEach((menu) => {
    if (menu.neverPublished) return;
    menu?.variants?.forEach((variant) => {
      const variantWithMmIdExists = allMenuVariants.find((item) => item?.mmId === variant?.mmId);
      if (!variantWithMmIdExists) {
        allMenuVariants.push(variant);
      }
    });
  });
  return allMenuVariants;
};

export const generateNestedCategories = (menu: Menu): NestedCategory[] => {
  return [...menu.categories]
    .sort((a, b) => a.displayOrder - b.displayOrder)
    .map((category) => {
      const products: Product[] = [];

      category.productIds.forEach((productId: string) => {
        const product = menu.products.find((product) => product.posId === productId);

        if (product) {
          products.push(product);
        }
      });

      return {
        __typename: category.__typename,
        category: category.category,
        description: category.description,
        displayOrder: category.displayOrder,
        id: category.mmId,
        imageUri: category.imageUri,
        products
      };
    });
};

export const getFormattedCategories = (menu: Menu): formattedCategory => {
  const formattedCategories: formattedCategory = (() => {
    const sortedCategories = [...menu.categories].sort((a, b) => a.displayOrder - b.displayOrder);

    const usedProductIds: string[] = [];

    return sortedCategories.reduce((acc: { [index: string]: string[] }, category) => {
      const { mmId, productIds } = category;
      acc[mmId] = productIds.map((productId) => {
        const amountOfTimesUsed = usedProductIds.filter((usedProductId) => usedProductId === productId).length;

        usedProductIds.push(productId);

        return `${productId}${CATEGORY_ITEM_IDENTIFIER}${amountOfTimesUsed}`;
      });

      return acc;
    }, {});
  })();

  return formattedCategories;
};
